import { set } from 'vue-gtag'

// What Google Analytics and Google Ads are told about the page. gtag takes the address
// bar as is, and the password reset, e-mail verification and sign-up links carry their
// token in the query string. Campaign parameters stay: GA4 reads the source of a visit
// from utm_* and the Google Ads click from gclid/gclsrc/gbraid/wbraid/gad_* in page_location.
const CAMPAIGN_PARAM =
  /^(utm_[a-z_]+|gclid|gclsrc|gbraid|wbraid|dclid|gad_[a-z_]+)$/i

// The query keeps only campaign parameters, the hash goes
export function cleanLocation(location) {
  const campaign = location.search
    .replace(/^\?/, '')
    .split('&')
    .filter(pair => CAMPAIGN_PARAM.test(pair.split('=')[0]))
  const query = campaign.length ? `?${campaign.join('&')}` : ''
  return `${location.protocol}//${location.host}${location.pathname}${query}`
}

// Every hit gtag sends after this (user engagement, scroll, Google Ads) gets the clean
// address instead of reading the address bar
export function setPageLocation() {
  const pageLocation = cleanLocation(window.location)
  set({ page_location: pageLocation })
  return pageLocation
}

// vue-gtag's pageTrackerTemplate: every page view, the first one included. page_path
// stays: the GA4 custom events for new members (oi_d_yeni_standart_üye on /uye/odeme,
// oi_d_yeni_kısıtlı_üye on /uye/kayit) match page_view on it
export function trackPage(to) {
  return {
    page_title: to.name,
    page_path: window.location.pathname,
    page_location: setPageLocation()
  }
}
